import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'relativeDate',
  standalone: true
})
export class RelativeDatePipe implements PipeTransform {
  private locale = inject(LOCALE_ID);
  private datePipe: DatePipe;
  private yesterdayLabels: Record<string, string> = {
    'en-US': 'Yesterday',
    'pt-BR': 'Ontem'
  };

  constructor() {
    this.datePipe = new DatePipe(this.locale);
  }

  transform(value?: Date | string | number, localeOverride?: string): string | null {
    const locale = localeOverride || this.locale;
    
    if (!value) return null;
    const date = new Date(value);
    const now = new Date();

    const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterdayMidnight = new Date(todayMidnight);
    yesterdayMidnight.setDate(yesterdayMidnight.getDate() - 1);

    if (date >= todayMidnight) {
      return this.datePipe.transform(date, 'shortTime', undefined, locale);
    } else if (date >= yesterdayMidnight) {
      const timePart = this.datePipe.transform(date, 'shortTime', undefined, locale);
      return `${this.getYesterdayLabel(locale)} ${timePart}`;
    } else {
      return this.datePipe.transform(date, 'short', undefined, locale);
    }
  }

  private getYesterdayLabel(locale: string): string {
    return this.yesterdayLabels[locale] || 'Yesterday';
  }
}